import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo, } from 'react';
import styleUtils from '../../styles/styleUtils';
import theme from '../../styles/theme';
const headerStyles = css `
${theme.typeStyles.titleLargeStyles}
  border-bottom: ${styleUtils.rem(1)} solid ${theme.colors.gray300};
  flex-grow: 0;
  padding-bottom: ${theme.spacing.x4};
  padding-left: ${theme.spacing.x6};
  padding-right: ${theme.spacing.x6};
  padding-top: ${theme.spacing.x4};
`;
const ModalHeader = ({ children, }) => (_jsx("div", Object.assign({ css: headerStyles }, { children: children })));
const MemoizedModalHeader = memo(ModalHeader);
export { MemoizedModalHeader as ModalHeader };
// MC-1068 Temporary hack for Storybook.
export default ModalHeader;
